module.exports = __webpack_public_path__ + "img/moto.2db36d7c.png";